import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';


@Injectable()
export class UsuariosService {

    constructor(
        private readonly _http: HttpClient
    ) { }

    public getIdiomas() {
        return this._http.get<any>(environment.apiEndpoint + '/Idioma/GetAll');
    }

    public getRolesUsuarios() {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/GetAllRoles');
    }

    public getRolesCreateUsuarios() {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/GetAllRolesGenericos');
    }

    public getAllUsuarios(usuario) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/GetAllUsuariosByFiltro', usuario);
    }

    public checkUsuarioExisteYAsociadoARol(usuario) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/CheckUsuarioExisteYAsociadoARol', usuario);
    }

    // USUARIOS
    public getUsuarios(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/GetAllUsuariosByFiltro', filters);
    }

    public getUsuario(usuarioId) {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/GetById?applicationUserId=' + usuarioId);
    }

    public createUsuario(usuario) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/RegisterUserCompleto', usuario);
    }

    public updateUsuario(usuario) {
        return this._http.put<any>(environment.apiEndpoint + '/ApplicationUser/UpdateUser', usuario);
    }

    public getMenuClaims() {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/GetMenuClaims?');
    }

    public getClaimsOfUser(userName: string, roleName: string) {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/GetClaimsOfUser?userName=' + userName + '&roleName=' + roleName);
    }

    public updateUserClaims(userName, userClaims) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/UpdateClaimsOfUser?userName=' + userName, userClaims);
    }

    public autoGeneratePassword(userName) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/AutoGenerarPasswordYEnviarCorreo', userName);
    }

    public deleteUserRole(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/DeleteRoleAUsuario', filters);
  }

    // CULTIVOS
    public getHuertosProductor(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/GetAllConFiltro', filters);
    }

    // PAISES
    public getPaisesDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    public getPaisByMunicipio(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    // PROVINCIAS
    public getProvinciasPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia/GetAllConFiltro', filters);
    }

    public getProvinciaByMunicipio(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia/GetAllConFiltro', filters);
    }

    // MUNICIPIOS
    public getMunicipiosProvincia(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    public getMunicipiosPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    public getPaisMunicipio(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    // DENOMINACIONES
    public getDenominacionesProductor(productorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Productor/GetAllProductorPaisDenominacion/?productorId=' + productorId);
    }

    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    // CAMPANYAS
    public getCampanyas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    // EMPACADORES
    public getEtiquetadores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllEtiquetadorApplicationUserConFiltro', filters);
    }

    public getEtiquetador(empacadorId, applicationUserId) {
        return this._http.get<any>(environment.apiEndpoint + '/Etiquetador/GetEtiquetadorApplicationUserById?etiquetadorId='
            + empacadorId + '&applicationUserId=' + applicationUserId);
    }

    public asociarUsuarioAEtiquetador(empacador) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/InsertUserYAsociaEtiquetador/', empacador);
    }

    public updateUsuarioAEmpacador(empacador) {
        return this._http.put<any>(environment.apiEndpoint + '/Etiquetador/UpdateRelacionEtiquetadorYCamposUsuario', empacador);
    }

    public deleteEtiquetador(etiquetadorId, applicationUserId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Etiquetador/DeleteEtiquetadorApplicationUser/?etiquetadorId='
        + etiquetadorId + '&applicationUserId=' + applicationUserId);
    }

    public enviarInvitacion(usuario) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/AppUserSolicitudRegistroEnvioEmail/', usuario);
    }

    public blockEtiquetador(usuario) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/LockUser', usuario);
    }

    // AUDITORES
    public getAuditores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Auditor/GetAllConFiltro', filters);
    }

    public getAuditor(auditorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Auditor/GetById?auditorId=' + auditorId);
    }

    public createAuditor(auditor) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/InsertUsuario', auditor);
    }

    public asociarUsuarioAAuditor(auditor) {
        return this._http.post<any>(environment.apiEndpoint + '/Auditor/InsertUserYAsociaAuditor', auditor);
    }

    public updateAuditor(auditor) {
        return this._http.put<any>(environment.apiEndpoint + '/Auditor/UpdateAuditorUsuarioAlertas', auditor);
    }

    public deleteAuditor(auditorId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Auditor/?id=' + auditorId);
    }

    public blockAuditor(usuario) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/LockUser', usuario);
    }

    // USUARIO GENERAL
    public updateUsuarioGeneral(usuario) {
        return this._http.put<any>(environment.apiEndpoint + '/ApplicationUser/UpdateUser', usuario);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }

}
